import { ALGOLIA_PRODUCT_INDEX } from '~/lib/constants'

import { getBranchEnv } from '~/utils/get-branch-env'

export default function getAlgoliaProductIndex(): string {
  const env = getBranchEnv()

  return `${env}_${ALGOLIA_PRODUCT_INDEX}`
}
